/** @format */

import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
	addMultipleReviewFilters,
	cleanReviewFilterRatings,
	removeSearchFilter,
	setSelectedFeature
} from '../actions';
import { selectReviewFilters, selectSearchFilter } from '../selects';

import { FilterType } from '../../model';
import { Injectable } from '@angular/core';
import { ProductReviewProsConsType } from '../../model/product-review-pros-cons.enum';
import { SelectedFilterType } from 'libs/product-reviews/components/src/lib/models/filter.interface';
import { Store } from '@ngrx/store';
import { concatLatestFrom } from '@ngrx/operators';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class ReviewAiProsConsEffects {
	constructor(
		private readonly actions$: Actions,
		private readonly store: Store
	) {}

	selectFeature$ = createEffect(() =>
		this.actions$.pipe(
			ofType(setSelectedFeature),
			concatLatestFrom(() => [
				this.store.select(selectReviewFilters),
				this.store.select(selectSearchFilter)
			]),
			switchMap(([{ selectedFeature }, reviewFilters, searchFilter]) => {
				const newSelection = selectedFeature;
				let filters = this.getRatingFilters(reviewFilters);
				const actions = [];

				if (newSelection && newSelection.type === ProductReviewProsConsType.CON) {
					filters = this.createRatingFilters([1, 2, 3]);
				} else if (newSelection && newSelection.type === ProductReviewProsConsType.PRO) {
					filters = this.createRatingFilters([3, 4, 5]);
				} else if (newSelection === null) {
					filters = [];
				}

				const shouldRemoveSearchFilter = searchFilter && newSelection;
				if (shouldRemoveSearchFilter) {
					actions.push(removeSearchFilter());
				}

				actions.push(cleanReviewFilterRatings(), addMultipleReviewFilters({ filters }));

				return of(...actions);
			})
		)
	);

	private getRatingFilters(reviewFilters: unknown) {
		if (!Array.isArray(reviewFilters)) {
			return [];
		}

		return reviewFilters.filter((filter) => filter.type === FilterType.RATING);
	}

	private createRatingFilters(ratings: number[]) {
		return ratings.map((rating) => ({
			id: `${FilterType.RATING}-${rating}`,
			label: `${rating} Star`,
			name: SelectedFilterType.RATING,
			type: FilterType.RATING,
			value: rating.toString()
		}));
	}
}
